module.exports = __webpack_public_path__ + "img/amex.92e7c4de.png";